import { PureComponent } from "react";
import ParagraphWithLogosComponent from "/components/core/paragraph-with-logos/paragraph-with-logos-component";
import { StyledSecurityAndPrivacyComponent } from "./security-and-privacy-component.scss";

const DEFAULT_SECURITY_ASSETS = [
  { url: "/static/img/security/gdpr.png", alt: "GDPR" },
  { url: "/static/img/security/iso-27001.png", alt: "ISO-27001" },
  { url: "/static/img/security/iso-27018.png", alt: "ISO-27018" },
  { url: "/static/img/security/soc.png", alt: "SOC" },
  { url: "/static/img/security/hipaa.png", alt: "HIPAA" }
];

export default class SecurityAndPrivacyComponent extends PureComponent {
  render() {
    return (
      <StyledSecurityAndPrivacyComponent className="security-and-privacy-component">
        <div className="paragraph-with-logos-wrapper">
          <ParagraphWithLogosComponent {...this.props} />
        </div>
      </StyledSecurityAndPrivacyComponent>
    );
  }
}

SecurityAndPrivacyComponent.defaultProps = {
  assets: DEFAULT_SECURITY_ASSETS,
  paragraph: {
    textDirection: "center",
    title: "We care about your privacy.",
    body: [
      "As users of our own product, we understand how important the security and privacy of your data is. We are committed to providing our customers with a highly secure and reliable environment for its cloud-based application. We have therefore developed a security model that covers all aspects of cloud-based monday.com systems."
    ]
  }
};
